import { eMauEmailActionsObj } from "../../action-types/thiet-lap/IMauEmailActions";
import { generateActions } from "../generateActions";

export const mauEmailActions = {
  ...generateActions(eMauEmailActionsObj, "MAU_EMAIL"),
};
